export default class TablePosition {
  constructor(container) {
    this.container = container
    this.sectorElem = $(this.container)
    this.sectorOffset = this.sectorElem.offset()
    this.startPosition = {}
    this.startElement = null
  }

  setStartCoordinates(event, pointer) {
    this.sectorOffset = this.sectorElem.offset()
    const draggableEl = event.target.closest('.draggable') || event.currentTarget
    this.startElement = draggableEl
    this.startPosition = {
      x: parseInt(draggableEl.style.left, 10) || 0,
      y: parseInt(draggableEl.style.top, 10) || 0
    }
  }

  saveCoordinates(event, pointer) {
    const draggableEl = this.startElement || event.target.closest('.draggable') || event.currentTarget
    const newX = parseInt(draggableEl.style.left, 10) || 0
    const newY = parseInt(draggableEl.style.top, 10) || 0

    if (newX < 0 || newY < 0) {
      draggableEl.style.left = this.startPosition.x + 'px'
      draggableEl.style.top = this.startPosition.y + 'px'
    } else {
      const id = draggableEl.dataset?.id
      if (id) {
        $.ajax({
          url: '/admin/tables/' + id,
          type: 'PUT',
          data: { restaurant_table: { position_x: newX, position_y: newY } }
        })
      }
    }
  }
}
